<div class="svg-loader" *ngIf="isLoading"></div>
<div class="largeModelContainer">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle alignCenter heading2" *ngIf="!userSinkVar">
    Model Specification: Data Source
  </div>
  <div class="modelTitle alignCenter heading2" *ngIf="userSinkVar">
    Model Specification: User Input
  </div>
  <div class="modelBody" *ngIf="!userSinkVar">
    <form #connectorSpecificationForm="ngForm">
      <div class="pr-4" [ngClass]="{'readOnly' : readOnly}">
        <div class="form-group row no-overflow connectors-form-group">
          <div class="col-sm-12 pad-lr">
            <div class="row mb-2">
              <div class="col-sm-3">
                <div class="row mb-2">
                  <div class="col-sm-12">
                    <label [for]="model.modelUniqueId" class="form-label"><strong>Model:</strong> {{model.modelUniqueId}}</label>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="d-flex table-container">
                    <div class="col-12">
                      <div class="example-container">
                        <div class="drag-drop-container-header">Variables</div>
                        <div class="prameterListCont">
                          <div cdkDropList
                               #inputParametersList="cdkDropList"
                               [cdkDropListData]="inputParameters"
                               [cdkDropListConnectedTo]="[variablesList]"
                               class="drag-drop-container-list"
                               (cdkDropListDropped)="drop($event)">
                            <div title="{{item.data.captionName}}" class="drag-drop-container-box" *ngFor="let item of inputParameters" cdkDrag>
                              <span *ngIf="item.data.captionName && item.data.captionName.length<=25">{{item.data.captionName}}</span>
                              <span *ngIf="item.data.captionName && item.data.captionName.length>25">{{item.data.captionName.slice(0,25)}}...</span>
                            </div>
                          </div>
                          <div *ngIf="model.inputParameters.length === 0 && !isLoading" class="emptyRepoMsg">
                            No parameters available
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="connectorContainer">
                  <div class="drag-drop-container-header pairedHeader">Variables Name</div>
                  <div class="drag-drop-container-header pairedHeader">Data Source</div>
                  <div class="clear"></div>
                  <div class="connectorPairs">
                    <div class="connectorSrcContainer">
                      <div cdkDropList
                           #variablesList="cdkDropList"
                           [cdkDropListData]="sinkConnVariablesList"
                           [cdkDropListConnectedTo]="[inputParametersList]"
                           class="drag-drop-container-list"
                           (cdkDropListDropped)="drop($event)">
                        <div title="{{item.data.captionName}}" class="drag-drop-container-box" *ngFor="let item of sinkConnVariablesList" cdkDrag>
                          <span *ngIf="item.data.captionName && item.data.captionName.length<=25">{{item.data.captionName}}</span>
                          <span *ngIf="item.data.captionName && item.data.captionName.length>25">{{item.data.captionName.slice(0,25)}}...</span>
                          <button class="actionIcon pointer matIconLink" mat-icon-button><mat-icon>link</mat-icon></button>
                        </div>
                      </div>
                    </div>
                    <div class="connectorSrcContainer">
                      <div cdkDropList
                           #sinkVariablesList="cdkDropList"
                           [cdkDropListData]="srcConnVariablesList"
                           class="drag-drop-container-list"
                           [cdkDropListConnectedTo]="[srcInputParametersList]"
                           (cdkDropListDropped)="drop($event)">
                        <div class="drag-drop-container-box" *ngFor="let item of srcConnVariablesList ;let i = index" cdkDrag>
                          {{item.mappedParameterName}}
                          <button class="actionIcon pointer" (click)="deleteMapping(i)" matTooltip="Delete" mat-icon-button>
                            <mat-icon class="action-icon-delete"></mat-icon>
                          </button>
                        </div>
                        </div>
                      </div>
                    <div class="clear"></div>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group row mb-3">
                  <label for="dataSourceName" class="col-sm-5 mt-2"><strong>Data Source: </strong></label>
                  <div class="col-sm-7">
                    <select class="custom-select form-control" id="dataSourceSelected"
                            [(ngModel)]="dataSourceSelected"
                            name="dataSourceSelected"
                            (change)="getDataSourceParameters()"
                            tabindex="-1" [disabled]="readOnly">
                      <option *ngFor="let item of dataSource" [ngValue]="item">{{item.dataSourceName}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row mb-3 position-relative">
                  <label for="frequncy" class="col-sm-5 mt-2"><strong>Frequency: </strong></label>
                  <div class="col-sm-7">
                    <input type="number" class="form-control" id="frequncy"
                           [(ngModel)]="frequncy"
                           name="name"
                           #name="ngModel"
                           tabindex="-1" [disabled]="readOnly">
                  </div>
                  <div class="freqMin"> Min</div>
                </div>
                <div class="form-group row mb-3">
                  <label for="parameters" class="col-sm-5 mt-2"><strong>Parameters: </strong></label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control prm_typehead"
                           id="parameters"
                           name="parameters"
                           #parameters="ngModel"
                           [(ngModel)]="selectedParameter"
                           [typeahead]="parameterList"
                           [typeaheadOptionField]="'srcParameter'"
                           (typeaheadOnSelect)="onSelectParameter($event.item)"
                           [typeaheadOptionsLimit]="5"
                           autocomplete="off"
                           tabindex="-1" [disabled]="readOnly">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modelFooter">
        <button class="saveBtn2 actionBtn" *ngIf="(inputParameters.length === 0) && !readOnly" [disabled]="!(sinkConnVariablesList.length > 0 && (sinkConnVariablesList.length === srcConnVariablesList.length))" (click)="saveMappingDetails()">Save</button>
        <button class="saveBtn2 actionBtn" *ngIf="inputParameters.length !== 0" [disabled]="!(srcConnVariablesList.length === sinkConnVariablesList.length)" (click)="saveMappingDetails()">Next</button>
        <button *ngIf="(model.inputParameters.length === 0) && readOnly" type="button" class="saveBtn2 actionBtn" (click)="onCancelClick()">Ok</button>
        <div class="clear"></div>
      </div>
    </form>
  </div>
  <div class="modelBody" *ngIf="userSinkVar">
    <form (ngSubmit)="onSubmit()" #f="ngForm" [formGroup]="myFormGroup">
      <div class="row connectorSpec justify-content-md-center">
        <div class="col-sm-11 paramContainer">
          <div class="row">
            <div *ngFor="let form_elem of form_template" class="col-sm-6">
              <div [ngSwitch]="form_elem.type">
                <div *ngSwitchCase="'textBox'" class="form-group row">
                  <label title="{{form_elem.label}}" [for]="form_elem.label" class="col-sm-5 col-form-label">
                    <span *ngIf="form_elem.label && form_elem.label.length<=25">{{form_elem.label}}</span>
                    <span *ngIf="form_elem.label && form_elem.label.length>25">{{form_elem.label.slice(0,25)}}...</span>
                  </label>
                  <div class="col-sm-5">
                    <input type="text" class="form-control" [id]="form_elem.label"
                           formControlName="{{form_elem.inputModel}}"
                           [attr.disabled]="readOnly ? '' : null">
                  </div>
                  <div class="col-sm-2 uomLabel">{{form_elem.uom}}</div>
                </div>
                <div *ngSwitchCase="'number'" class="form-group row">
                  <label title="{{form_elem.label}}" [for]="form_elem.label" class="col-sm-5 col-form-label">
                    <span *ngIf="form_elem.label && form_elem.label.length<=25">{{form_elem.label}}</span>
                    <span *ngIf="form_elem.label && form_elem.label.length>25">{{form_elem.label.slice(0,25)}}...</span>
                  </label>
                  <div class="col-sm-5">
                    <input type="number" class="form-control" [id]="form_elem.label"
                           formControlName="{{form_elem.inputModel}}"
                           required [attr.disabled]="readOnly ? '' : null">
                  </div>
                  <div class="col-sm-2 uomLabel">{{form_elem.uom}}</div>
                </div>
                <div *ngSwitchCase="'checkbox'" class="form-group row">
                  <label title="{{form_elem.label}}" [for]="form_elem.label" class="col-sm-5 col-form-label">
                    <span *ngIf="form_elem.label && form_elem.label.length<=25">{{form_elem.label}}</span>
                    <span *ngIf="form_elem.label && form_elem.label.length>25">{{form_elem.label.slice(0,25)}}...</span>
                  </label>
                  <div class="col-sm-5">
                    <input type="checkbox" class="form-control" [id]="form_elem.label"
                           formControlName="{{form_elem.inputModel}}" [attr.disabled]="readOnly ? '' : null">
                  </div>
                  <div class="col-sm-2 uomLabel">{{form_elem.uom}}</div>
                </div>
              </div>
            </div>
            <div *ngFor="let linkedItem of sinkConnVariablesList" class="col-sm-6">
              <div class="form-group row">
                <label title="{{linkedItem.data.captionName}}" [for]="linkedItem.data.captionName" class="col-sm-5 col-form-label">
                  <span *ngIf="linkedItem.data.captionName && linkedItem.data.captionName.length<=25">{{linkedItem.data.captionName.label}}</span>
                  <span *ngIf="linkedItem.data.captionName && linkedItem.data.captionName.length>25">{{linkedItem.data.captionName.slice(0,25)}}...</span>
                </label>
                <div class="col-sm-5">
                  <input type="text" class="form-control" disabled>
                </div>
                <div class="col-sm-2 matIconLink"><mat-icon>link</mat-icon></div>
              </div>
            </div>
            <div *ngFor="let linkedItem of sinkVariablesConnToSrcModel" class="col-sm-6">
              <div class="form-group row">
                <label title="{{linkedItem.data.captionName}}" [for]="linkedItem.data.captionName" class="col-sm-5 col-form-label">
                  <span *ngIf="linkedItem.data.captionName && linkedItem.data.captionName.length<=25">{{linkedItem.data.captionName.label}}</span>
                  <span *ngIf="linkedItem.data.captionName && linkedItem.data.captionName.length>25">{{linkedItem.data.captionName.slice(0,25)}}...</span>
                </label>
                <div class="col-sm-5">
                  <input type="text" class="form-control" disabled>
                </div>
                <div class="col-sm-2 matIconLink"><mat-icon>link</mat-icon></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modelFooter">
        <button class="saveBtn2 actionBtn mr-15" (click)="gotoPrev()">Previous</button>
        <button *ngIf="!readOnly" type="button" class="saveBtn2 actionBtn" (click)="onSubmit()" [disabled]="!f.valid">Save</button>
        <button *ngIf="readOnly" type="button" class="saveBtn2 actionBtn" (click)="onCancelClick()">Close</button>
        <div class="clear"></div>
      </div>
    </form>
  </div>
</div>

